import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPosts } from "../../features/posts/postsSlice";
import Loading from "../ui/Loading";
import PostGridItem from "./PostGridItem";

export default function PostGrid() {
  const dispatch = useDispatch();
  const { posts, isLoading, isError, error } = useSelector(
    (state) => state.posts
  );
  const { sort, filter } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  const filterByFilter = (post)=>{
    if(filter === 'All'){
      return post;
    }
    if(filter === 'Saved'){
      return post.isSaved === true;
    }
  }
  const filterBySort = (a,b)=>{ 
    if(sort === ''){
      return a;      
    }      
    if(sort === 'newest'){
      return new Date(b.createdAt) - new Date(a.createdAt);
    }
    if(sort === 'liked'){      
      return b.likes - a.likes;
    }
  }

  // decide what to render
  let content;
  if (isLoading) content = <Loading />;
  if (!isLoading && isError)
      content = <h1>{error}</h1>;

  if (!isError && !isLoading && posts?.length === 0) {
      content = <h1>No post found!</h1>;
  }

  if (!isError && !isLoading && posts?.length > 0) {
      content = posts.filter(filterByFilter).sort(filterBySort).map((post) => (
          <PostGridItem key={post.id} post={post} />
      ));
  }

  return (
    <main className="post-container" id="lws-postContainer">
     {content}
    </main>
  );
}
